// extracted by mini-css-extract-plugin
export default {"cards":"locationValue2_cards__mrB2z","info":"locationValue2_info__S7Mzm","infoText":"locationValue2_infoText__46qwL","options":"locationValue2_options__sVMGT"};